import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuditLogs() {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/audit").then((r) => { setList(r.data); setLoading(false); });
    }, []);

    return (
        <div className="space-y-5" data-testid="audit-page">
            <div>
                <p className="prc-label-overline">監査ログ</p>
                <h1 className="text-[1.685rem] font-bold tracking-tight">アクセス・操作ログ</h1>
                <p className="text-sm text-[var(--prc-muted)] mt-1">改ざん防止のためタイムスタンプ付きで記録されます。</p>
            </div>
            <div className="prc-card overflow-x-auto">
                {loading ? <p className="p-4 text-sm">読込中…</p> :
                    <table className="prc-table" data-testid="audit-table">
                        <thead>
                            <tr><th>日時</th><th>アクション</th><th>対象</th><th>詳細</th></tr>
                        </thead>
                        <tbody>
                            {list.map((a) => (
                                <tr key={a.id} data-testid={`audit-${a.id}`}>
                                    <td className="num text-xs">{String(a.created_at).substring(0, 19).replace("T", " ")}</td>
                                    <td className="font-mono text-xs">{a.action}</td>
                                    <td>{a.target || "-"}</td>
                                    <td className="text-xs text-[var(--prc-muted)]">{JSON.stringify(a.meta || {})}</td>
                                </tr>
                            ))}
                            {list.length === 0 && <tr><td colSpan="4" className="text-center text-sm text-[var(--prc-muted)] p-8">ログなし</td></tr>}
                        </tbody>
                    </table>}
            </div>
        </div>
    );
}
